// src/hooks/useDateTimeFormat.js
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  formatDate,
  formatDateTime,
  formatTime,
  getDateTimeConfigForLanguage,
} from "../utils/dateTime";

/**
 * Returns date/time formatters bound to the user's current i18n language, so
 * UTC timestamps are shifted into the matching timezone (e.g. JST for Japanese)
 * and styled for that locale.
 */
export function useDateTimeFormat() {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return useMemo(() => {
    const { locale, timeZone } = getDateTimeConfigForLanguage(language);
    return {
      locale,
      timeZone,
      formatDateTime: (input) => formatDateTime(input, { locale, timeZone }),
      formatDate: (input) => formatDate(input, locale, timeZone),
      formatTime: (input) => formatTime(input, locale, timeZone),
    };
  }, [language]);
}
